module.exports = {"pathContext":{"name":"FeeCalculationMethod","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Calculate fees based on aging buckets (30/60/90/121+ days)","isDeprecated":false,"name":"AGED_BUCKETS"},{"deprecationReason":null,"description":"Calculate fees based on recurring intervals (every X days)","isDeprecated":false,"name":"INTERVAL"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-fee-calculation-method.json
// module id = 1247
// module chunks = 63040629406883